import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import HealthCell from 'features/IRWorkstation/components/Common/HealthCell';
import { LP_COLUMNS } from 'features/IRWorkstation/constants/lpColumns';
import { formatDate } from 'utils/utils';

const PLACEHOLDER = '-';

const renderers = {
	// Date-only strings — format in UTC to avoid a day shift (CR-6566).
	date: ({ value }) => formatDate(value, true) || PLACEHOLDER,
	// null (not 0) means the aggregate failed — keeps "unknown" distinct from "none".
	count: ({ value }) => (value == null ? PLACEHOLDER : value),
	health: ({ value }) => <HealthCell value={value} />,
};

// The LP name links to its LP360 page with an "All LPs" back-breadcrumb (AC).
const renderAccountCell = ({ row, value }, getAccountLink) => {
	const link = row.id && getAccountLink?.(row);

	if (!value || !link) return value || PLACEHOLDER;

	return (
		<Link
			component={RouterLink}
			to={link.to}
			state={link.state}
			onClick={link.onClick}
			sx={{
				fontWeight: 500,
				color: 'primary.main',
				textDecoration: 'none',
				'&:hover': { textDecoration: 'underline' },
			}}
		>
			{value}
		</Link>
	);
};

// The account cell needs a link builder from the page, so columns are built per render.
const buildAllLpsGridColumns = (getAccountLink, columnDefs = LP_COLUMNS) =>
	columnDefs.map(({ label, sortKey, field, type, align, minWidth }) => {
		const column = {
			field,
			headerName: label,
			sortable: Boolean(sortKey),
			minWidth,
			flex: 1,
			disableColumnMenu: true,
			...(align && { align, headerAlign: align }),
		};

		if (type === 'account') {
			return {
				...column,
				renderCell: (params) => renderAccountCell(params, getAccountLink),
			};
		}

		if (renderers[type]) {
			return { ...column, renderCell: renderers[type] };
		}

		return { ...column, renderCell: ({ value }) => value || PLACEHOLDER };
	});

export default buildAllLpsGridColumns;
